import { combineReducers } from "redux";
import projectDetails from "./projectDetails";
import projectArray from "./projectArray";
import user from "./user";

export const reducers = combineReducers({
    projectArray,
    projectDetails,
    user
})